// Configuration for navigation sections
// Edit this file to control which sections are visible in the app

const navigationConfig = {
  sections: {
    home: {
      enabled: true,      // Controls visibility in navbar and footer
      label: 'Home',
      path: '/'
    },
    myStories: {
      enabled: false,      // Controls visibility in navbar and footer
      label: 'My Stories',
      path: '/my-stories'
    },
    createStory: {
      enabled: true,      // Controls visibility in navbar and footer
      label: 'Create a Story',
      path: '/create/1-write'
    },
    pricing: {
      enabled: false,      // Controls visibility in navbar and footer
      label: 'Pricing',
      path: '/pricing'
    }
  }
};

export default navigationConfig; 